import React from 'react';
import { parse } from 'query-string';
import {
  Datagrid,
  TextField,
  FunctionField,
  DateField,
  useRedirect,
  BooleanField,
} from 'react-admin';

import CustomList from '../../Components/CustomList';
import FullNameField from '../../Components/FullNameField';
import { BlacklistSegment } from '../../Utils/enums';

const Blacklist = ({ permissions, ...props }) => {
  const redirect = useRedirect();
  const { segment } = parse(props.location.search);
  const normalizedSegment = segment ? segment.toString().toLowerCase() : null;

  return (
    <CustomList
      filter={normalizedSegment ? { segment: normalizedSegment } : {}}
      actions={<></>}
      {...props}
    >
      <Datagrid>
        <TextField source="data.id" emptyText="-" />
        <FunctionField
          source="data"
          render={(record) => {
            if (!record?.data || !record.data.id) return null;
            switch (record.segment.toLowerCase()) {
              case BlacklistSegment.Person.toLowerCase():
                return (
                  <div
                    onClick={() => redirect(`/people/${record.data.id}/show`)}
                  >
                    <FullNameField
                      record={record}
                      source="data"
                      entity="data"
                    />
                  </div>
                );
              case BlacklistSegment.LegalPerson.toLowerCase():
                return (
                  <TextField
                    source="data.businessName"
                    onClick={() =>
                      redirect(`/legal-people/${record.data.id}/show`)
                    }
                  />
                );
              case BlacklistSegment.Franchise.toLowerCase():
                return (
                  <TextField
                    source="data.name"
                    onClick={() =>
                      redirect(`/franchises/${record.data.id}/show`)
                    }
                  />
                );
              default:
                return '-';
            }
          }}
        />
        {normalizedSegment === BlacklistSegment.Franchise.toLowerCase() ? (
          <TextField source="data.code" />
        ) : (
          <TextField source="data.documentNumber" />
        )}
        <FunctionField
          source="agent"
          render={(record) => {
            if (!record?.data) return '-';

            return record.data.agent
              ? `${record.data.agent?.code ?? ''} | ${
                  record.data.agent?.person?.firstName ?? ''
                } ${record.data.agent?.person?.fatherLastName ?? ''}`
              : '-';
          }}
        />
        <TextField source="dictum.code" emptyText="-" />
        <BooleanField source="data.blacklist" emptyText="-" />
        <DateField source="created_at" showTime={false} locales="es-MX" />
        <DateField source="exitDate" showTime={false} locales="es-MX" />
      </Datagrid>
    </CustomList>
  );
};

export default Blacklist;
